export default __webpack_public_path__ + "/dist/images/buyers-map.0cffa2d7ca5e875b236774ebfc26bd75.png";